import React from "react";
import { USDollar, toNumber } from "./utils";

export default function TopStudents({ period, topSize, onDrill }) {
  const rows = period?.topStudents || [];

  return (
    <div className="w-full border rounded-lg overflow-hidden">
      <div className="bg-gray-100 border-b p-3">
        <h2 className="text-sm font-bold">
          Top {topSize} Ranking Delinquency Report
        </h2>
        <p className="text-xs font-extralight text-gray-500">
          Students with the largest open balance on {period?.reference_date || "-"}
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr className="bg-gray-50 border-b">
              <th className="text-left p-3 font-semibold text-gray-700 w-20">
                Position
              </th>
              <th className="text-left p-3 font-semibold text-gray-700">
                Student
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">
                Total $
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">
                # Invoices
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={4} className="p-6 text-center text-gray-500">
                  No overdue students for this period
                </td>
              </tr>
            )}
            {rows.map((row, index) => (
              <tr
                key={`${row.student_id || row.issuer_id}-${row.position}`}
                onClick={() =>
                  onDrill({
                    reference_date: period.reference_date,
                    student_id: row.student_id || undefined,
                    issuer_id: row.student_id ? undefined : row.issuer_id,
                    title: row.name,
                  })
                }
                className={`border-b cursor-pointer hover:bg-green-50 transition-colors ${
                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                }`}
              >
                <td className="p-3 font-medium">{row.position}</td>
                <td className="p-3">
                  {row.name}
                  {row.registration_number && (
                    <span className="text-gray-400">
                      {" "}
                      · {row.registration_number}
                    </span>
                  )}
                </td>
                <td className="p-3 text-right font-semibold">
                  {USDollar.format(toNumber(row.total))}
                </td>
                <td className="p-3 text-right">{toNumber(row.invoices)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
